import { Box, CloseButton, MediaOverlay, Popover, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import React, { useState } from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
export const HeadingStructureRuleGenericContentPopover = _ref => {
  let {
    videoPath,
    isSeo,
    status,
    index
  } = _ref;
  const [popoverShown, setPopoverShown] = useState(false);
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const headingText = isSeo ? 'accessibility-wizard.rules-list.heading-definition.errors.generic.seo' : 'accessibility-wizard.rules-list.heading-definition.errors.generic.html';
  const togglePopover = isShown => {
    if (isShown) {
      biLogger.taskElementCtaClick({
        ctaName: BiCtaNames[isSeo ? 'SeoAccessibilityModal' : 'HTMLTagModal'],
        index,
        status: status === ElementStatus.Passed ? ElementStatus.ManualPassed : status === ElementStatus.Failed ? ElementStatus.ManualFailed : status
      });
    }
    setPopoverShown(isShown);
  };
  return /*#__PURE__*/React.createElement(Popover, {
    appendTo: "viewport",
    placement: "right",
    shown: popoverShown,
    zIndex: 9999,
    animate: true,
    showArrow: true,
    onClickOutside: () => togglePopover(false),
    onKeyDown: e => {
      if (e.key === 'Escape' || e.key === 'Tab') {
        togglePopover(false);
        e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    skin: "dark",
    underline: "always",
    onClick: () => {
      biLogger.taskElementCtaClick({
        ctaName: BiCtaNames[isSeo ? 'SeoAccessibility' : 'HTMLTag'],
        index,
        status: status === ElementStatus.Passed ? ElementStatus.ManualPassed : status === ElementStatus.Failed ? ElementStatus.ManualFailed : status
      });
      togglePopover(!popoverShown);
    }
  }, isSeo ? t('accessibility-wizard.rules-list.heading-definition.errors.generic.seoTextButton') : t('accessibility-wizard.rules-list.heading-definition.errors.generic.htmlTextButton'))), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "12px 16px 24px 16px"
  }, /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    size: "medium",
    skin: "dark",
    onClick: () => togglePopover(false)
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    height: "170px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      boldText: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: headingText
  })), /*#__PURE__*/React.createElement(Box, {
    borderRadius: "4px",
    boxShadow: "0px 2px 4px rgba(0, 6, 36, 0.12), 0px 0px 6px rgba(0, 6, 36, 0.12)",
    height: "126px",
    marginTop: "12px",
    width: "200px"
  }, /*#__PURE__*/React.createElement(MediaOverlay, {
    media: /*#__PURE__*/React.createElement("video", {
      "aria-hidden": "true",
      src: videoPath,
      style: {
        height: '100%',
        objectFit: 'cover',
        width: '100%'
      },
      autoPlay: true,
      controls: true,
      muted: true
    })
  }))))));
};
//# sourceMappingURL=heading-structure-rule-generic-content-popover.js.map